/**
 * Format duration in seconds to human-readable string
 * @param {number} seconds - Duration in seconds
 * @returns {string} Formatted duration (e.g., "1h 23m", "45m 30s", "30s")
 */
export const formatDuration = (seconds) => {
  if (!seconds || seconds === 0) {
    return '—';
  }

  const duration = Math.round(seconds);
  
  if (duration < 60) {
    return `${duration}s`;
  } else if (duration < 3600) {
    const minutes = Math.floor(duration / 60);
    const remainingSeconds = duration % 60;
    if (remainingSeconds > 0) {
      return `${minutes}m ${remainingSeconds}s`;
    }
    return `${minutes}m`;
  } else {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    const remainingSeconds = duration % 60;
    
    if (minutes > 0 && remainingSeconds > 0) {
      return `${hours}h ${minutes}m ${remainingSeconds}s`;
    } else if (minutes > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${hours}h`;
  }
};

/**
 * Format duration in seconds to short format (e.g., "1:23:45", "45:30", "0:30")
 * @param {number} seconds - Duration in seconds
 * @returns {string} Short formatted duration
 */
export const formatDurationShort = (seconds) => {
  if (!seconds || seconds === 0) {
    return '—';
  }

  const duration = Math.round(seconds);
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const secs = duration % 60;

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  } else {
    return `${minutes}:${String(secs).padStart(2, '0')}`;
  }
};

